<template lang="pug">
  a-row(type="flex" justify="space-around")
    a-col.progress-container(:flex="1")
      a-progress.progress(gapPosition="top" :width="90" :stroke-width="10" type="dashboard" :stroke-color="progressColor" :percent="Math.min(coursesCount / 15 * 100, 100)" :show-text="false")
        template(#format="percent")
          h4 {{ coursesCount }} {{ smaller(coursesCount, 14) ? "門" : "畢業門" }}
    a-col.progress-container(:flex="2")
      a-progress.progress(gapPosition="top" :width="150" :stroke-width="20" type="dashboard" :stroke-color="progressColor" :percent="Math.min(credits / 40 * 100, 100)" :show-text="false")
        template(#format="percent")
          h3 {{ credits }} {{ smaller(credits, 30) ? "學分" : "學分費" }}
    a-col.progress-container(:flex="1")
      a-progress.progress(gapPosition="top" :width="90" :stroke-width="10" type="dashboard" :stroke-color="progressColor" :percent="Math.min(hours / 50 * 100,100)" :show-text="false")
        template(#format="percent")
          h4 {{ hours }} {{ smaller(hours, 40) ? "時數" : "肝指數" }}

</template>
<script>
export default {
  name: 'dashboard',
  data: function () {
    return {
      progressColor: {
          '0%': '#87d068',
          '100%': '#202020',
        }
    }
  },
  methods: {
    smaller(l, r) {
      return l < r
    }
  },
  computed: {
    credits() {
      let value = this.coursesGroup.list.reduce((ori, next) => ori += parseInt(next.credit) || 0, 0)
      // console.log('credits',value)
      return value
    },
    coursesCount() {
      return this.coursesGroup.list.length
    },
    hours() {
      let value = this.coursesGroup.list.reduce((ori, next) => ori += parseInt(next.hours) || 0, 0)
      // console.log('hours',value)
      return value
    },
  },
}
</script>
<style>
h1, h2, h3, h4, h5, h6 {
  text-align: center;
}

.progress-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
